import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { GenderData, GetAllCategory } from "../action";
import Home from "./Home";

/**
 * Renders the Home page, but ensures gender is set via route.
 * This gives distinct URLs (/female, /male, /kids, /life) instead of always /home.
 */
export default function GenderHomeRoute({ gender }) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!gender) return;
    dispatch(GenderData(gender));
    dispatch(GetAllCategory({ genderBased: gender }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gender]);

  return <Home />;
}

